import React from "react";
import diamondIcon from "../../images/icon/diamond-icon02.gif";
import miVideo from "../../images/video/intro-presentacion.mp4";

const FullscreenVideo: React.FC = () => {
  return (
    <section className="feature pt-145">
      {/* TÍTULO normal con container */}
      <div className="container">
        <div className="sec-title sec-title-center fea-sec-title text-center mb-50">
          <span className="sub-title">Nuestros Valores</span>
          <h2 className="title">
            Nuestros{" "}
            <span>
              <img src={diamondIcon} alt="icon" />
            </span>{" "}
            valores
          </h2>
        </div>
      </div>

      {/* VIDEO full-width, fuera del container */}
      <div className="fullscreen-video-bleed">
        <video
          className="fullscreen-video"
          src={miVideo}
          autoPlay
          muted
          loop
          playsInline
        />
      </div>
    </section>
  );
};

export default FullscreenVideo;
